// extracted by mini-css-extract-plugin
export default {"main":"tC6Zqon99dRjpASx7WXc","main__notfound":"udNnlF2zVtta0uOVrqi3","main__title":"kjkjwUSWFtMbjBUs_7QJ","main__cards":"heySwLDMA49tVAWYjrO6"};